import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/fireLogo.png'
import _imports_1 from '../assets/game/gameTips.png'
import _imports_2 from '../assets/game/anWay.png'
import _imports_3 from '../assets/game/iosWay.png'
import _imports_4 from '../assets/game/pcWay.png'
import _imports_5 from '../assets/game/throughLine.png'
import _imports_6 from '../assets/game/gameLogo.png'
import _imports_7 from '../assets/game/bottom_banner.png'


const _withScopeId = n => (_pushScopeId("data-v-695d86ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "all" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", null, "首页"),
  /*#__PURE__*/_createElementVNode("span", null, "|")
], -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "banner" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "section1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "tips"
}, null, -1))
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_18 = { class: "mask" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "扫描二维码 下载游戏", -1))
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "dowlandWay" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "through",
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_30 = { class: "hotGame" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "hotgameTitle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "热门游戏")
], -1))
const _hoisted_32 = { class: "gameCard" }
const _hoisted_33 = { class: "cardInfo" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "cardInfoText" }
const _hoisted_36 = ["href"]
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })
], -1))
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"footer\" data-v-695d86ec><div class=\"footerInfo\" data-v-695d86ec><img src=\"" + _imports_0 + "\" alt=\"\" data-v-695d86ec><div class=\"companyInfo\" data-v-695d86ec><p data-v-695d86ec>© 苏州燃火网络科技有限公司 | 江苏省苏州市昆山市</p><p data-v-695d86ec>用户隐私协议 | 用户服务协议 | 投诉信箱 | 合作信箱</p><p data-v-695d86ec><a href=\"https://beian.miit.gov.cn/\" data-v-695d86ec>备案号: 苏ICP备2022048589号-2</a></p><p data-v-695d86ec> 抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当 适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活 </p></div></div></div>", 1)

import { onMounted, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const state: any = reactive({
  down: [],
  gameslide: [],
  lists: [],
  rmgames: [],
});

onMounted(() => {
  // console.log("onmounted------------");
  getInfo();
});

const getInfo = async () => {
  fetch("http://www.98pk.com/index/index/indexlists", {
    method: "POST",
    headers: {
      "Content-Type": "application.json()",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      // console.log('data---------',data.data)
      (state.down = data.data.down),
        (state.gameslide = data.data.gameSlide),
        (state.lists = data.data.lists),
        (state.rmgames = data.data.rmgames);
    });
  console.log("页面信息-------", state);
};

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _hoisted_3,
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: state.down.dhdown
          }, "导航电脑登陆器下载", 8, _hoisted_4)
        ]),
        _hoisted_5,
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: state.down.apkdown
          }, "安卓下载", 8, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: state.down.iosdown
          }, "IOS下载", 8, _hoisted_8),
          _hoisted_9
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            href: state.down.lxkf
          }, "联系客服", 8, _hoisted_10)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_van_swipe, {
        class: "my-swipe",
        autoplay: 3000,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.gameslide, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_swipe_item, {
              key: index + 'slid_img'
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: item.slide_pic
                }, null, 8, _hoisted_12)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lists, (item, index) => {
            return (_openBlock(), _createElementBlock("li", null, [
              _hoisted_15,
              _createElementVNode("img", {
                src: item.pic1,
                alt: ""
              }, null, 8, _hoisted_16),
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("img", {
                  src: item.pic4,
                  alt: ""
                }, null, 8, _hoisted_20),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    href: item.android_url
                  }, _hoisted_24, 8, _hoisted_22),
                  _createElementVNode("a", {
                    href: item.ios_url
                  }, _hoisted_27, 8, _hoisted_25),
                  _hoisted_28
                ])
              ]),
              _createElementVNode("span", null, _toDisplayString(item.gamename), 1)
            ]))
          }), 256)),
          _hoisted_29
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.rmgames, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("img", {
                src: item.pic3,
                alt: ""
              }, null, 8, _hoisted_34),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h4", null, _toDisplayString(item.gamename), 1),
                _createElementVNode("p", null, _toDisplayString(item.welfare), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: item.android_url
                  }, "安卓下载", 8, _hoisted_36),
                  _createElementVNode("a", {
                    href: item.ios_url
                  }, "IOS下载", 8, _hoisted_37),
                  _createElementVNode("a", {
                    href: item.game_web
                  }, "PC端下载", 8, _hoisted_38)
                ])
              ])
            ]))
          }), 256))
        ])
      ]),
      _hoisted_39
    ]),
    _hoisted_40
  ]))
}
}

})